import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
function initials(author: string): string {
  return author.replace(/[^A-Za-zÀ-ÿ]/g, '').slice(0, 2).toUpperCase();
}
export function TestimonialsSection() {
  return <section className="defer-paint w-full bg-canvas py-12 sm:py-14" aria-labelledby="testimonials-heading" data-id="element-182" data-mp="1mxxxd8vmeqlo">
      <div className="mx-auto max-w-6xl px-6" data-id="element-183" data-mp="1qz9kn7r0uzqp">
        <div className="mx-auto max-w-2xl text-center" data-id="element-184" data-mp="1d0tepj0zhd9m">
          <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-accent" data-id="element-185" data-mp="1i0xut7xzc5zb">In sala</p>
          <h2 id="testimonials-heading" className="mt-4 font-serif text-[2.2rem] font-bold leading-[1.05] text-ink sm:text-[2.6rem]" data-id="element-186" data-mp="141g2wjpe0clq">
            Cosa dicono le insegnanti
          </h2>
        </div>

        <ul className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-187" data-mp="2yeo02i0u50aj">
          {testimonials.map(testimonial => <li key={testimonial.author} className="flex h-full flex-col rounded-3xl border border-line bg-card p-6" data-id="element-188" data-mp="32gj0lkaxz9n9">
              <div className="flex gap-1" role="img" aria-label="5 stelle su 5" data-id="element-189" data-mp="2v0sw7ddrmc5h">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-accent text-accent" aria-hidden="true" data-id="element-190" data-mp="2q0ex4ku56cjl" data-mpi={index} />)}
              </div>

              <blockquote className="mt-4 font-sans text-[0.9rem] leading-relaxed text-ink" data-id="element-191" data-mp="2zskpvws7wxzu">
                “{testimonial.quote}”
              </blockquote>

              <footer className="mt-auto flex items-center gap-3 pt-6" data-id="element-192" data-mp="2c2ypj6040cq9">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-accent/25 bg-accent-soft font-serif text-base font-bold text-accent" aria-hidden="true" data-id="element-193" data-mp="274x78naichfu">
                  {initials(testimonial.author)}
                </span>
                <span className="font-sans text-sm" data-id="element-194" data-mp="1a5lj5cs1p5a">
                  <span className="block font-semibold text-ink" data-id="element-195" data-mp="1cru98bemap3">
                    {testimonial.author}
                  </span>
                  <span className="block text-xs text-muted" data-id="element-196" data-mp="3f0v9mpdo0x0">
                    {testimonial.role} · {testimonial.location}
                  </span>
                </span>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}